import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import AuthPanel from './AuthPanel';

function RequireAuth() {
  const location = useLocation();
  const { status } = useAuth();

  if (status === 'bootstrapping') {
    return (
      <AuthPanel
        eyebrow="Account"
        title="Checking your session"
        description="We are restoring your sign-in before loading this page."
      >
        <p className="auth-panel-meta mb-0">One moment while we confirm your account access.</p>
      </AuthPanel>
    );
  }

  if (status !== 'authenticated') {
    return (
      <Navigate
        replace
        state={{
          from: {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
          },
          authMessage: 'Please log in to continue.',
        }}
        to="/login"
      />
    );
  }

  return <Outlet />;
}

export default RequireAuth;
